export default function formatNumberBr(numero: string): string {
  const ddd = numero.substring(0, 2);
  const parte1 = numero.substring(2, 7);
  const parte2 = numero.substring(7);

  return `(${ddd}) ${parte1}-${parte2}`;
}
